import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Design System
import Form from 'jl-design-system/components/form/Form';
import { setFieldValue } from 'jl-design-system/redux/actions/form/formActions';

// Types
import { AppDispatch } from 'types/RootState.types';
import { SavedPaymentDetailsFormProps } from './SavedPaymentDetailsForm.types';

// Config
import savedPaymentDetailsFormState from './SavedPaymentDetailsForm.state';
import getSavedCardDetailsFormConfig, { SAVED_CARD_DETAILS_FORM_ID } from '../../../utils/form/configs/savedCardDetails';
import { getObfuscatedPanString } from '../../../utils/helpers/cardDetails';

// Styles
import styles from './saved-payment-details-form.scss';

const SavedPaymentDetailsForm = ({
  disabled = false,
  paymentDetails = {},
  resetAfterError,
  securityCodeOnly = false,
  useInitialValues = false,
}: SavedPaymentDetailsFormProps) => {
  const dispatch: AppDispatch = useDispatch();
  const {
    confirmedDeliveryAddress,
    selectedBillingAddress,
    selectedDeliveryChoiceId,
  } = useSelector(savedPaymentDetailsFormState);

  const resetFieldValue = () => dispatch(setFieldValue(SAVED_CARD_DETAILS_FORM_ID, 'securityCode', ''));

  useEffect(() => {
    resetFieldValue();
  }, []);

  useEffect(() => {
    if (resetAfterError !== undefined) {
      resetFieldValue();
    }
  }, [resetAfterError]);

  const config = getSavedCardDetailsFormConfig({
    cardType: paymentDetails?.type,
    securityCodeLength: paymentDetails?.securityCodeLength,
    securityCodeOnly,
    selectedBillingAddress,
    confirmedDeliveryAddress,
    selectedDeliveryChoiceId,
  });

  const initialValues = useInitialValues ? {
    cardNumber: getObfuscatedPanString(paymentDetails.obfuscatedPan || ''),
    cardholderName: paymentDetails?.nameOnCard,
    expiryDate: `${paymentDetails?.expirationMonth}/${paymentDetails?.expirationYear?.slice(-2)}`,
  } : undefined;

  return (
    <div className={styles.savedCardDetailsWrapper}>
      <Form
        config={config}
        data-testid="saved-payment-details-form"
        disabled={disabled}
        form={config.id}
        initialValues={initialValues}
        multiFormValidation
      />
    </div>
  );
};

export default SavedPaymentDetailsForm;
